import { AddNewConfiguration } from "../../api/Api";
import { useState} from 'react';
import { useForm, FormProvider } from "react-hook-form";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { addOrModifyConfiguration } from '../../Models/AddOrModifyConfigurationRequest';
import { authCredentials } from '../../Models/AuthCredentials';
import CredentialComponent from './CredentialComponent';
import Card from '../Card/Card';

function AddConfiguration(){
    const [showAlert, setShowAlert] = useState(false);
    const [alertData, setAlertData] = useState({});

    const methods = useForm();
    const { handleSubmit, register, reset } = methods;

    async function onSubmit(data){
        let newConfiguration = new addOrModifyConfiguration(data.productName, data.configurationName, data.description, data.value);
        let credentials = new authCredentials(data.username, data.password);

        try {
            let response = await AddNewConfiguration(newConfiguration, credentials);
            handleResponse(response);
        } catch (err) {
            handleResponse(err.response);
        }
    }

    function handleResponse(response){
        if (response.status === 200){
            setShowAlert(true);
            let data = {
                variant:'primary', 
                heading:`Request status: ${response.status}`, 
                message:response="The Configuration has been added successfully"
            }
            reset();
            setAlertData(data);
        } else if (response.status === 204) {
            setShowAlert(true);
            let data = {
                variant: 'warning',
                heading: `Request status: ${response.status}`,
                message: response = "The Configuration already exists. No changes were made."
            }
            setAlertData(data);
        } else if (response.status === 400){
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:"Invalid Login"
            }
            setAlertData(data);
        } else if (response.status === 401){
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:"User is not authorized"
            }
            setAlertData(data);
        } else {
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:response=response.data.Message
            }
            setAlertData(data);
        }
    }

    return (
        <section >
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group>
                        <Form.Label>Configuration Name</Form.Label>
                        <Form.Control type='text' required name="configurationName" {...register('configurationName')} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Product Name</Form.Label>
                        <Form.Control type='text' required name="productName" {...register('productName')} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Description</Form.Label>
                        <Form.Control type='text' required name="description" {...register('description')} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Value</Form.Label>
                        <Form.Control type='text' required name="value" {...register('value')} />
                    </Form.Group>
                    <CredentialComponent />
                    <Button variant="secondary" type='submit'>Submit</Button>
                </Form>
            </FormProvider>
            <br />
            <Card show={showAlert} variant={alertData.variant} heading={alertData.heading} message={alertData.message}></Card>
        </section>
    );
}

export default AddConfiguration;